export const getBaseURL = () => process.env.REACT_APP_SERVER_BASE_URL || 'http://grant-connect-dev.herokuapp.com/'

export const reCaptchaKey = '6LdiFWcUAAAAAPkIywdkwENMC_gDUeUJ9IrCZqee'

export const userflowToken = 'ct_ujlibuvdwza5hcdr2hcd4x6s7e'
